module.exports = __webpack_public_path__ + "img/ourprocess-mobile-min-cropped.746ebe9.jpg";